// extracted by mini-css-extract-plugin
export default {"main":"newsResponse_main__ulX5R"};